<template lang="pug">
.imagenes-container
  div(v-show="refugioImages.length")
    div(v-show="hideLoading")
      swiper.swiper(:options="swiperOption" v-show="refugioImages.length")
        <!-- slides -->
        swiper-slide(
          v-for="(item, index) in refugioImages"
          :key="`refugioSwiperSlide${index}`"
        )
          img.image(:src="item.link" ref="refugioImgElements")

        <!-- Optional controls -->
        .swiper-pagination(slot="pagination")
    div.loading(v-show="!hideLoading")
      div
        md-progress-spinner(md-mode="indeterminate")
      span.fuentes Cargando imágenes ...
  div(v-show="!refugioImages.length")
    | No hay imagenes disponibles para este refugio

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  mounted () {
    this.isMounted = true
  },
  data: () => ({
    isMounted: false,
    totalImages: 0,
    imagesCount: 0,
    hideLoading: false,
    swiperOption: {
      pagination: {
        el: '.swiper-pagination'
      }
    }
  }),
  methods: {
    onLoadImages (event) {
      this.imagesCount += 1
    }
  },
  computed: {
    ...mapGetters({ refugioImg: 'imagenesByCurrentRefugioNro' }),
    refugioImages () {
      return (this.refugioImg && this.refugioImg.imagenes) || []
    },
    refugioImgElements () {
      if (!this.isMounted) return
      return this.$refs.refugioImgElements
    }
  },
  watch: {
    refugioImgElements (images) {
      if (images) {
        this.totalImages = this.refugioImages.length
        images.forEach($img => {
          $img.addEventListener('load', this.onLoadImages.bind(this))
        })
      }
    },
    imagesCount (val) {
      if (val >= this.totalImages) {
        this.hideLoading = true
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

.swiper
  height: $f300px
  width: 100%
  padding-bottom: $f30px
  &.swiper-container-horizontal > .swiper-pagination-bullets
    bottom: - $f5px

.image
  display: block
  margin: auto
  height: "calc(%s - %s)" % ($f300px 28px)
  width: 100%

.loading
  display: flex
  flex-direction: column
  align-items: center

</style>
